import { render, staticRenderFns } from "./EditMediaTypeModal.vue?vue&type=template&id=3d4b6c31&lang=pug&"
import script from "./EditMediaTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditMediaTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports